export const ANONYMOUS_LAUNCHDARKLY_KEY = 'anonymous';
